import { icon } from "../functions/icons";

export function InformationPill({icon2, title, content}){
    return(
        <div title={title} className="horizontal standard-padding information-pill">
            <div className="profile-info" style={{flexShrink: 1, marginTop: "4px"}}>{icon(icon2)}</div>
            <div style={{flexGrow: 1}} className="profile-info">{content}</div>
        </div>
    )
}